import React, { useContext, useState } from 'react';
import { useEffect } from 'react';
import CustomerContext from 'Components/CustomComponents/Context/CustomerContext';
import useFetchGet from 'Components/CustomComponents/Fetch/useFetchGet';
import Job from './Job'

function JobLogic({ defaultFormData }) {
  const [currentJobTitle, setCurrentJobTitle] = useState();
  const [jobDescription, setJobDescription] = useState((defaultFormData?defaultFormData.JobDescription:''))
  const {
    cookies,
    formData,
    setFormData
  } = useContext(CustomerContext)
  const {REACT_APP_API_URL} = process.env
  const {data: jobTitles} = useFetchGet((formData.Department&&`${REACT_APP_API_URL}/OrderRequest/getallordefaultskillcodes?token=${cookies.get('customer').Token}&CustomerID=${formData.Department.CustomerID}`),cookies)
  const [formattedJobTitles, setFormattedJobTitles] = useState();

  useEffect(()=>{
    const FormatJobTitles = (jobTitles) => { 
      if(jobTitles.data.length>0){
        setFormattedJobTitles(jobTitles.data.map(jobTitle=>{
          return {value:jobTitle, label:jobTitle.JobTitle}
        }))
      }else{
        setFormattedJobTitles(jobTitles.alldata.map(jobTitle=>{
          jobTitle.jobDescription = jobTitle.SkillCodeDescription
          return {value:jobTitle, label:jobTitle.SkillCodeDescription}
        }))
      }
     }

     if(jobTitles){
      FormatJobTitles(jobTitles)
     }

  },[jobTitles])

  const HandleJobTitleChange = (e) => { 
    formData.JobTitle = e.value
    formData.JobDescription = e.value.jobDescription
    setJobDescription(e.value.jobDescription)
    setFormData(formData)
    setCurrentJobTitle(e.value)
    // forceUpdate()
   }

  const HandleDateChange = (e, fieldName) =>{
    formData[fieldName] = e.target.value;
    setFormData(formData)
  }

  const HandleJobDescChange = (event) => { 
    formData.JobDescription = event.target.value;
    setFormData(formData)
   }

  return (
    <Job
      HandleJobTitleChange={HandleJobTitleChange}
      cookies={cookies}
      formData={formData}
      currentJobTitle={currentJobTitle}
      HandleDateChange={HandleDateChange}
      HandleJobDescChange={HandleJobDescChange}
      defaultFormData={defaultFormData}
      jobDescription={jobDescription}
      formattedJobTitles={formattedJobTitles}
    ></Job>
  )
}

export default JobLogic